import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuditReportParams, AuditLogsResponse, AuditUIReport } from 'app/shared/models/audit';
import { Config } from './config';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class AuditService {
    constructor(public http: HttpClient) {}

    public getAuditDetails(auditParams: AuditReportParams) {
        return this.http
            .post<AuditLogsResponse>(Config.serviceUrl + Config.urls.auditReports, auditParams)
            .pipe(catchError((err, caught) => caught))
            .pipe(
                map((res) => {
                    if (res == null) {
                        return;
                    }

                    const auditReport: AuditUIReport = {
                        count: res.count,
                        details: res.details.map((audit) => {
                            return {
                                customerid: audit.cid,
                                customername: audit.cust_name,
                                action: audit.action,
                                locationid: audit.lid,
                                locationname: audit.loc_name,
                                timestamp: audit.timestamp,
                                modifiedby: audit.modified_by,
                                username: audit.user_name,
                            };
                        }),
                    };

                    return auditReport;
                }),
            );
    }
}
